// app/javascript/controllers/messages_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "input", "form"]

  connect() {
    this.scrollToBottom()
  }

  scrollToBottom() {
    if (this.hasListTarget) {
      this.listTarget.scrollTop = this.listTarget.scrollHeight
    }
  }

  submitOnEnter(event) {
    // Submit on Enter, but allow Shift+Enter for new line
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.formTarget.requestSubmit()
    }
  }

  send(event) {
    // Clear input after submit
    setTimeout(() => {
      if (this.hasInputTarget) {
        this.inputTarget.value = ""
        this.inputTarget.style.height = "auto"
      }
      this.scrollToBottom()
    }, 100)
  }
}
